import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverline,
} from '@frontend/components';

import { pluralize } from 'utils/stringUtils';

import { BulkEditProfitItemsDrawerForm } from './BulkEditProfitItemsDrawerForm';
import * as actions from './data/actions';
import { getIsOpen, getComponents } from './data/reducer';

export const BulkEditProfitItemsDrawer = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsOpen);
  const components = useSelector(getComponents);

  const onClose = useCallback(() => dispatch(actions.close()), [dispatch]);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size="lg">
      <DrawerContent>
        <DrawerHeader>
          <DrawerOverline>
            {pluralize('Quote Item', components.length)}
          </DrawerOverline>
          Update Pricing Items
          <DrawerCloseButton />
        </DrawerHeader>
        <BulkEditProfitItemsDrawerForm />
      </DrawerContent>
    </Drawer>
  );
};
